import React from 'react';
import { ConfirmationModal } from '../../../../../components/ConfirmationModal';
import { OfferService } from '../../../../../services/v1/applicant_tracking/OfferService';
import { AlertObject, AlertType } from '../../../../../components/Alert';
import { ApiError } from '../../../../../services/ApiService/errors/ApiError';
import { getNounWithPossessiveCase } from '../../../../../utils/grammar';
import { Offer } from '../../../../../entities/v1/applicant_tracking/Offer';

interface PropTypes {
  id: number;
  isOpen: boolean;
  reloadApplication: () => void;
  setAlert: (alertObject: AlertObject) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export function RevokeOfferModal(props: PropTypes) {
  async function handleConfirm() {
    await OfferService.revoke(props.id)
      .then((offer: Offer) =>
        props.setAlert({
          type: AlertType.Warning,
          message: (
            <span>
              <b>
                {getNounWithPossessiveCase(
                  offer.application?.candidate?.name || 'Candidate',
                )}
              </b>{' '}
              Offer for <b>{offer.application?.job?.name || 'the job'}</b> was
              successfully revoked!
            </span>
          ),
        }),
      )
      .catch((e: ApiError) =>
        props.setAlert({
          type: AlertType.Danger,
          message: e.body?.message || 'It was not possible to revoke the offer',
        }),
      );

    props.setIsOpen(false);
    props.reloadApplication();
  }

  return (
    <ConfirmationModal
      title='Revoking Offer'
      body={<span>Are you sure you want to revoke this Offer?</span>}
      isOpen={props.isOpen}
      onConfirm={handleConfirm}
      onCancel={() => props.setIsOpen(false)}
      confirmText='Revoke'
      size='md'
    />
  );
}
